module.exports = __webpack_public_path__ + "static/media/Grabbi_Location.09fa2207.png";